import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAdminAuth } from "../lib/auth";
import { Skull, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { user, login, error } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) navigate("/admin");
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-6 relative overflow-hidden">
      <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "url(https://images.unsplash.com/photo-1589194837807-30a2f9540ad9?crop=entropy&cs=srgb&fm=jpg&q=70&w=1600)", backgroundSize: "cover" }} />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/85 to-black" />

      <div className="relative w-full max-w-md">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-3 mb-3">
            <Skull size={32} className="text-blood" strokeWidth={1.5} />
            <span className="font-display text-3xl font-bold tracking-[0.04em] text-blood">SCARE AUDITIONS<span className="text-[0.45em] font-semibold tracking-normal align-top opacity-80 ml-1">.co.uk</span></span>
          </div>
          <h1 className="font-display text-3xl font-black uppercase tracking-tight">Admin Sign In</h1>
          <p className="text-[#A19D94] text-sm mt-2">Casting Control Room</p>
        </div>

        <form onSubmit={submit} className="border border-[#1a1a1a] bg-[#0A0A0A] p-8 space-y-5">
          {error && <div className="p-3 border border-blood/40 bg-blood/10 text-sm text-blood" data-testid="login-error">{error}</div>}
          <div>
            <label className="label-mini block mb-1.5">Email</label>
            <input
              data-testid="login-email"
              type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required
              className="w-full bg-[#050505] border border-[#262626] px-3 py-2.5 text-sm focus:outline-none focus:border-blood transition-colors"
              placeholder="you@example.com"
            />
          </div>
          <div>
            <label className="label-mini block mb-1.5">Password</label>
            <input
              data-testid="login-password"
              type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required
              className="w-full bg-[#050505] border border-[#262626] px-3 py-2.5 text-sm focus:outline-none focus:border-blood transition-colors"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-btn"
            className="w-full py-3 bg-blood text-white font-display uppercase tracking-wider hover:bg-[#FF3333] disabled:opacity-50 transition-colors flex items-center justify-center gap-2"
          >
            {loading && <Loader2 size={14} className="animate-spin" />}
            Enter the Dashboard
          </button>
        </form>

        <div className="mt-6 text-center">
          <a href="/" className="text-xs text-[#4a4842] hover:text-[#A19D94] tracking-wider uppercase">← Public Application</a>
        </div>
      </div>
    </div>
  );
}
